import { useState } from "react"
import { ReactSVG } from "react-svg"
import Box from "component-lib/Base/components/Box"
import { makeStyles } from "tss-react/mui"
import getContentUrl from "utils-lib/getContentUrl"
import { getWindow } from "utils-lib/getWindow"
import { FormattedTextField } from "../../../../../Base"
import "./GlobalAlert.scss"

const useStyles = makeStyles()((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.main,
  },
  title: {
    color: theme.palette.common.white,
  },
  subtext: {
    color: theme.palette.common.white,
    [theme.breakpoints.down(`md`)]: {
      marginLeft: 41,
    },
  },
}))

const GlobalAlert = ({ title, subtext, trackingCode, logo, iconClose }) => {
  const ssrWindow = getWindow()
  const { classes } = useStyles()

  const [hideAlert, setHideAlert] = useState(
    ssrWindow.localStorage.getItem(`${trackingCode}_visited`),
  )

  if (hideAlert) {
    return null
  }

  function hideNotification() {
    setHideAlert(true)
    ssrWindow.localStorage.setItem(`${trackingCode}_visited`, true)
  }

  return (
    <div
      className={`${classes.root} GlobalAlert py-4`}
      data-testid="GlobalAlert"
    >
      <div className="container">
        {/* MOBILE */}
        <div className="d-lg-none">
          <div className="d-flex align-items-center">
            <Box mr={1}>
              <ReactSVG
                wrapper="span"
                src={getContentUrl(logo)}
                className="pr-2"
                style={{ height: `20px` }}
              />
            </Box>
            <Box flexGrow={1} mr={3}>
              <FormattedTextField
                variant="subheading2"
                component="div"
                className={classes.title}
              >
                {title}
              </FormattedTextField>
            </Box>
            <button
              type="button"
              alt="close alert"
              className="p-0"
              aria-label="hide"
              data-testid="GlobalAlert-hideNotification"
              onClick={hideNotification}
              style={{
                background: `transparent`,
              }}
            >
              <ReactSVG wrapper="span" src={getContentUrl(iconClose)} />
            </button>
          </div>
          <Box>
            <FormattedTextField variant="body2" className={classes.subtext}>
              {subtext}
            </FormattedTextField>
          </Box>
        </div>
        {/* DESKTOP */}
        <div className="d-none d-lg-block">
          <div className="d-flex align-items-center">
            <Box mr={1}>
              <ReactSVG
                wrapper="span"
                src={getContentUrl(logo)}
                className="pr-2"
                style={{ height: `20px` }}
              />
            </Box>
            <div>
              <Box flexGrow={1} mr={3}>
                <FormattedTextField
                  variant="subheading2"
                  component="div"
                  className={classes.title}
                >
                  {title}
                </FormattedTextField>
              </Box>
              <Box>
                <FormattedTextField variant="body2" className={classes.subtext}>
                  {subtext}
                </FormattedTextField>
              </Box>
            </div>
            <button
              type="button"
              alt="close alert"
              className="p-0"
              aria-label="hide"
              onClick={hideNotification}
              style={{
                background: `transparent`,
              }}
            >
              <ReactSVG wrapper="span" src={getContentUrl(iconClose)} />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// GlobalAlert.propTypes = {
//   title: PropTypes.string.isRequired,
//   subtext: PropTypes.string.isRequired,
//   trackingCode: PropTypes.string.isRequired,
//   logo: PropTypes.string.isRequired,
//   iconClose: PropTypes.string.isRequired,
// }

export default GlobalAlert
